<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Inspect" class="d-icon d-icon--inspect" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><path fill="currentColor" fill-rule="evenodd" d="M1.44 1.44A1.5 1.5 0 0 1 2.5 1h7A1.5 1.5 0 0 1 11 2.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 1 9.5v-7c0-.398.158-.78.44-1.06Z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M5.646 5.646a.5.5 0 0 1 .54-.11l5 2a.5.5 0 0 1-.002.929l-1.949.77-.77 1.949a.5.5 0 0 1-.93.002l-2-5a.5.5 0 0 1 .111-.54Zm1.252 1.252 1.1 2.749.387-.98a.5.5 0 0 1 .281-.282l.98-.388-2.748-1.1Z" clip-rule="evenodd"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconInspect',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
